"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ThumbUp16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_2932_2739)" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6105 5H12.5079H12.51H12.9407C14.8977 5 16.3307 6.84351 15.848 8.74004L14.767 12.9867C14.3158 14.7593 12.7197 16 10.8906 16H6H4H2H0V14V8V6H2H4L5.65811 1.02566C5.86228 0.413146 6.43549 0 7.08114 0H7.13254C8.94708 0 10.414 1.3729 10.6105 3.09903C10.6382 3.34269 10.6407 3.59339 10.6152 3.84826L10.6105 3.89501L10.511 4.89005C10.5051 4.94892 10.5513 5 10.6105 5H11.6105ZM6 6.32456V8V14H10.8906C11.8052 14 12.6032 13.3796 12.8288 12.4934L13.9098 8.24668C14.0707 7.6145 13.593 7 12.9407 7H10.6105C9.36809 7 8.3973 5.92728 8.52092 4.69104L8.6251 3.64926C8.70319 2.8683 8.16985 2.17871 7.43161 2.02971L6 6.32456ZM4 8H2V14H4V8Z", fill: "#131416" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_2932_2739" },
                react_1.default.createElement("rect", { width: 16, height: 16, fill: "white" }))));
}
function ThumbUp16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ThumbUp16Svg, Object.assign({}, svgProps)));
}
exports.default = ThumbUp16;
//# sourceMappingURL=ThumbUp16.js.map